import React from "react";
import { createStandardRegistrationValidators } from "./registrationEmailValidation";
import { RegistrationPasswordFieldsSection } from "./RegistrationPasswordFieldsSection";

function passwordFieldProps(...args) {
  return {
    formData: args[0],
    handleInputChange: args[1],
    validatePassword: args[2],
    validateConfirmPassword: args[3],
    passwordError: args[4],
    confirmPasswordError: args[5],
    primaryColor: args[6],
    onKeyDown: args[7],
  };
}

function buildPasswordFields(pageKey, passwordSectionOptions, fieldProps) {
  return (
    <RegistrationPasswordFieldsSection
      key={pageKey}
      {...fieldProps}
      {...passwordSectionOptions}
    />
  );
}

function createRegistrationPageUi(pageKey, options = {}) {
  const { validatorOptions = {}, passwordSectionOptions = {}, passwordOnly = false } = options;

  function composePasswordFields(...args) {
    return buildPasswordFields(pageKey, passwordSectionOptions, passwordFieldProps(...args));
  }

  if (passwordOnly) {
    return { composePasswordFields };
  }

  return {
    compose({
      formData,
      setEmailError,
      setUsernameError,
      passwordError,
      confirmPasswordError,
      primaryColor,
      handleInputChange,
      validatePassword,
      validateConfirmPassword,
    }) {
      const { validateEmail, validateUsername } = createStandardRegistrationValidators({
        formData,
        setEmailError,
        setUsernameError,
        ...validatorOptions,
      });
      return {
        validateEmail,
        validateUsername,
        passwordFields: composePasswordFields(
          formData,
          handleInputChange,
          validatePassword,
          validateConfirmPassword,
          passwordError,
          confirmPasswordError,
          primaryColor
        ),
      };
    },
  };
}

export const REGISTRATION_PAGE_UI_SHARED_REGISTER = createRegistrationPageUi("shared-register", {
  validatorOptions: {
    emailField: "email_address",
    emailOptions: { requiredMessage: "Email address is required" },
  },
});

export const REGISTRATION_PAGE_UI_LAW_FIRM = createRegistrationPageUi("law-firm-user");
export const REGISTRATION_PAGE_UI_TEAM_MEMBER = createRegistrationPageUi("team-member");

export const REGISTRATION_PAGE_UI_PG_CONTACT = createRegistrationPageUi("pg-contact", {
  passwordSectionOptions: {
    confirmPlaceholder: "Re-enter your password here",
    confirmTooltip: "Re-enter your password to confirm",
  },
});

export const REGISTRATION_PAGE_UI_PROF_GUARDIAN = createRegistrationPageUi("prof-guardian", {
  passwordOnly: true,
  passwordSectionOptions: {
    passwordTooltip:
      "Create a strong password with at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character",
    confirmTooltip: "Re-enter your password to confirm it matches",
  },
});

export const REGISTRATION_PAGE_UI_FIRST_TIME = {
  composeValidators(formData, setErrors) {
    return createStandardRegistrationValidators({
      formData,
      setEmailError: (error) => setErrors((prev) => ({ ...prev, email: error })),
      setUsernameError: (error) => setErrors((prev) => ({ ...prev, username: error })),
      emailOptions: { requiredMessage: "Email address is required" },
    });
  },
};
